import type { SpartacuxTrackingState } from '../tracking.state';

export const selectRequesterType = (state: SpartacuxTrackingState) =>
  state.tracking?.user?.requesterType;
